import $ from "jquery";
import modalHtml from "./templates/modal.html";
import viewHtml from "./templates/view.html";
import liquidjs from "./../liquidjs";

const PropertyModalWidget = (($) => {
  const Liquid = new liquidjs.Liquid();

  const NAME = "PropertyListMapWidget";
  const VERSION = "4.1.1";
  const DATA_KEY = "nh.propertyListMapWidget";
  const EVENT_KEY = `.${DATA_KEY}`;
  const DATA_API_KEY = ".data-api";
  const JQUERY_NO_CONFLICT = $.fn[NAME];

  const Selector = {
    MODAL_ELEMENT: ".nhw-modal",
    MODAL_CONTENT_ELEMENT: ".nhw-modal-content",
    INFO_WINDOW_LINK: ".nhw-map-property-info-window",
  };

  const CssClass = {
    MODAL_SHOW: "nhw-show",
    MODAL_BODY_SHOW: "nhw-modal-open",
  };

  const Api = {
    ENDPOINT: "/_system/api/listings",
  };

  const TemplateTypes = {
    listing: {
      name: "listing",
      default: viewHtml,
      dataTag: "listingTemplate",
    },
  };

  class PropertyModalWidget {
    constructor() {
      this._loading = true;
      this._body = document.body;
      this._cache = {
        templates: {},
      };
      this._element = document.createElement("div");
      this._element.classList.add("nhw-property-modal");
      this._element.innerHTML = modalHtml;

      this._modalElement = $(Selector.MODAL_ELEMENT, this._element)[0];
      this._modalContentElement = $(
        Selector.MODAL_CONTENT_ELEMENT,
        this._element
      )[0];

      this._backdropElement = document.createElement("div");
      this._backdropElement.classList.add(
        "nhw-modal-backdrop",
        "nhw-fade",
        "nhw-show"
      );

      this._modalElement.addEventListener("click", () => {
        this.hide();
      });

      this._modalContentElement.addEventListener("click", () => {});

      this._body.appendChild(this._element);

      this._init();
      this._render();
    }

    static get VERSION() {
      return VERSION;
    }

    _getTemplate(type) {
      if (!this._cache.templates[type.name]) {
        this._cache.templates[type.name] = Liquid.parse(type.default);
      }
      return this._cache.templates[type.name];
    }

    _init() {}

    _render() {
      if (this._loading) {
        return;
      }

      const template = this._getTemplate(TemplateTypes.listing);
      if (template) {
        Liquid.render(template, { name: "test" }).then((html) => {
          this._modalContentElement.innerHTML = html;
        });
      }
    }

    show(id) {
      console.dir("got to here");
      if (!this._body.classList.contains(CssClass.MODAL_BODY_SHOW)) {
        this._body.classList.add(CssClass.MODAL_BODY_SHOW);
      }

      this._modalElement.style.display = "block";
      if (!this._modalElement.classList.contains(CssClass.MODAL_SHOW)) {
        this._modalElement.classList.add(CssClass.MODAL_SHOW);
      }

      this._body.appendChild(this._backdropElement);

      if (id) {
        this._id = id;
        let endpoint = `${Api.ENDPOINT}/${this._id}`;

        $.ajax(endpoint, {
          method: "GET",
        })
          .done((data) => {
            this._data = data;
            this._loading = false;

            this._render();
          })
          .fail(() => {});
      }
    }

    hide() {
      this._body.classList.remove(CssClass.MODAL_BODY_SHOW);

      this._modalElement.style.display = "none";
      if (this._modalElement.classList.contains(CssClass.MODAL_SHOW)) {
        this._modalElement.classList.remove(CssClass.MODAL_SHOW);
      }

      this._modalContentElement.innerHTML = "";

      this._backdropElement.remove();
    }
  }

  return PropertyModalWidget;
})($);

export default PropertyModalWidget;
